import React, { useState } from "react";
import moment from "moment/moment";
import SearchInput from "./SearchInput";
import CustomSelect from "./CustomSelect";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { Link } from "react-router-dom";
import { hasPermission, isAdmin } from "../../Utils/auth";
import { FiEdit } from "react-icons/fi";
import EnableDisableRadio from "./EnableDisableRadio";
import Popup from "./Popup";
import { formatCurrency } from "../../Utils/getUserUtitls";
import { FaFilePdf } from "react-icons/fa";

const EmployeePayrollTable = ({
  data,
  designationOptions,
  handleDisableEnable,
}) => {
  const [search, setSearch] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [pageInput, setPageInput] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedUserStatus, setSelectedUserStatus] = useState("");
  const [disableOpen, setDisableOpen] = useState(false);

  // ⬅️ UPDATED: Filter ONLY by location here (NOT search)
  const filteredData = data.filter((row) => {
    return locationFilter === "Dubai"
      ? row?.user?.location_id === 1
      : locationFilter === "India"
      ? row?.user?.location_id === 2
      : true;
  });

  // Pagination
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // ⬅️ UPDATED: Search ONLY inside current page rows
  const currentRows = paginatedRows.filter((row) => {
    const name = `${row?.user?.first_name || ""} ${
      row?.user?.last_name || ""
    }`.toLowerCase();
    return name.includes(search.toLowerCase());
  });

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePageJump = (e) => {
    e.preventDefault();
    const pageNum = parseInt(pageInput, 10);
    if (!isNaN(pageNum)) {
      handlePageChange(pageNum);
      setPageInput("");
    }
  };

  const locationOptions = [
    { label: "All Countries", value: "" },
    { label: "Dubai", value: "Dubai" },
    { label: "India", value: "India" },
  ];

  const handleDisable = (emp, userStatus) => {
    setSelectedEmployee(emp);
    setSelectedUserStatus(userStatus === 1 ? "Disable" : "Enable");
    setDisableOpen(true);
  };

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      <div className="flex justify-between items-start md:flex-row gap-3 mb-4">
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name..."
          fontSize="sm"
        />
        <div className="flex flex-grow-0 flex-shrink-0 gap-4">
          <CustomSelect
            options={locationOptions}
            placeholder="Country"
            value={locationFilter}
            onChange={(opt) => setLocationFilter(opt.value)}
            width="[120px]"
            height="36px"
            fontSize="sm"
            optionFontSize="sm"
          />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-sm">
          <thead>
            <tr className="h-[52px] bg-white border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left text-sm font-semibold">
                Employee Name
              </th>
              <th className="px-4 text-left text-sm font-semibold">
                Designation
              </th>
              <th className="px-4 text-left text-sm font-semibold">
                Monthly Salary
              </th>
              <th className="px-4 text-left text-sm font-semibold">
                Allowance
              </th>
              <th className="px-4 text-left text-sm font-semibold">
                Deductions
              </th>
              <th className="px-4 text-left text-sm font-semibold">
                Net Salary
              </th>
              <th className="px-4 text-left text-sm font-semibold">Action</th>
            </tr>
          </thead>

          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row, idx) => (
                <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                  <td className="relative text-center py-3 pl-3">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 overflow-hidden rounded-lg bg-[#de2b26] flex items-center justify-center">
                        <span className="text-sm text-white">
                          {row?.user?.first_name
                            ? row?.user?.first_name.charAt(0)
                            : "N"}
                        </span>
                      </div>
                      <p className="text-sm ">
                        {row?.user?.first_name
                          ? row?.user?.first_name + " " + row?.user?.last_name
                          : "N/A"}
                      </p>
                    </div>
                  </td>

                  <td className="text-sm text-left py-3 px-4">
                    {row?.user?.designation
                      ? row?.user?.designation.title
                      : "N/A"}
                  </td>

                  <td className="text-sm text-left py-3 px-4">
                    <b className="text-[12px] align-top">
                      {row?.user?.location_id === 1 ? "AED " : "₹ "}
                    </b>
                    {row.basic_salary
                      ? formatCurrency(
                          (
                            parseFloat(row.basic_salary) +
                            parseFloat(row.hra) +
                            parseFloat(row.ta)
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </td>

                  <td className="text-sm text-left py-3 px-4">
                    <b className="text-[12px] align-top">
                      {row?.user?.location_id === 1 ? "AED " : "₹ "}
                    </b>
                    {row.total_earnings
                      ? formatCurrency(row.total_earnings)
                      : "0.00"}
                  </td>

                  <td className="text-sm text-left py-3 px-4">
                    <b className="text-[12px] align-top">
                      {row?.user?.location_id === 1 ? "AED " : "₹ "}
                    </b>
                    {row.total_deductions
                      ? formatCurrency(row.total_deductions)
                      : "0.00"}
                  </td>

                  <td className="text-left py-3 px-4">
                    <b className="text-[12px] align-top">
                      {row?.user?.location_id === 1 ? "AED " : "₹ "}
                    </b>
                    {row.net_salary ? formatCurrency(row.net_salary) : "0.00"}
                  </td>

                  <td className="text-right py-3 px-4">
                    <div className="flex justify-center gap-2">
                      {row?.payslip && (
                        <Link
                          to={row?.payslip?.file_path}
                          target="_blank"
                          className="flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#142b70]/10 cursor-pointer"
                        >
                          <FaFilePdf
                            className="text-xs text-[#142b70]"
                            size={15}
                          />
                        </Link>
                      )}

                      {!row?.payslip && (
                        <Link
                          to={`/edit-salary/${row.id}`}
                          className="flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#142b70]/10 cursor-pointer"
                        >
                          <FiEdit className="text-xs text-[#142b70]" />
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <Popup
          isOpen={disableOpen}
          onClose={() => setDisableOpen(false)}
          title="Disable Employee"
        >
          <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
            <p className="text-sm">
              Are you sure you want to {selectedUserStatus.toLowerCase()}{" "}
              <b>{selectedEmployee?.employee_name}</b>?
            </p>
          </div>

          <div className="flex justify-end gap-4">
            <button
              onClick={() => setDisableOpen(false)}
              className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
            >
              Cancel
            </button>
            <button
              onClick={() =>
                handleDisableEnable(selectedUserStatus, selectedEmployee?.id)
              }
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
            >
              {selectedUserStatus}
            </button>
          </div>
        </Popup>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm">of {totalPages} pages</p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeePayrollTable;
